// Auto-generated by scripts/split_ui.js from data/medkit.js — do not edit.
export const MEDKIT_UI = {
  "title": {
    "id": "Obat & Perlengkapan Medis Penting ke Tanah Suci",
    "en": "Essential Medicines & Medical Supplies for the Holy Land",
    "ar": "الأدوية والمستلزمات الطبية الضرورية للأراضي المقدسة",
    "fr": "Médicaments et fournitures médicales essentiels pour la Terre Sainte",
    "de": "Wichtige Medikamente und medizinische Ausstattung für das Heilige Land",
    "es": "Medicamentos y suministros médicos esenciales para Tierra Santa",
    "ru": "Необходимые лекарства и медицинские принадлежности для поездки на Святую землю",
    "zh": "前往圣地必备药品与医疗用品",
    "ja": "聖地への必須医薬品・医療用品",
    "ko": "성지 순례를 위한 필수 의약품 및 의료용품",
    "hi": "पवित्र भूमि के लिए आवश्यक दवाएँ और चिकित्सा सामग्री"
  },
  "subtitle": {
    "id": "Daftar obat yang perlu dibawa, catatan kaki penting, dan referensi resmi (Kemenkes, Saudi MoH, SFDA, WHO, CDC)",
    "en": "List of medicines to bring, important footnotes, and official references (Kemenkes, Saudi MoH, SFDA, WHO, CDC)",
    "ar": "قائمة الأدوية الواجب حملها، وملاحظات مهمة، ومراجع رسمية (كيمنكيس، وزارة الصحة السعودية، SFDA، WHO، CDC)",
    "fr": "Liste des médicaments à emporter, notes importantes et références officielles (Kemenkes, ministère de la Santé saoudien, SFDA, OMS, CDC)",
    "de": "Liste der mitzunehmenden Medikamente, wichtige Fußnoten und offizielle Referenzen (Kemenkes, Saudi MoH, SFDA, WHO, CDC)",
    "es": "Lista de medicamentos que llevar, notas al pie importantes y referencias oficiales (Kemenkes, Ministerio de Salud saudí, SFDA, OMS, CDC)",
    "ru": "Список лекарств для поездки, важные примечания и официальные источники (Kemenkes, Минздрав Саудовской Аравии, SFDA, ВОЗ, CDC)",
    "zh": "须携带药品清单、重要脚注及官方参考资料（Kemenkes、沙特卫生部、SFDA、WHO、CDC）",
    "ja": "持参すべき薬のリスト、重要な注記、および公式参考資料（Kemenkes、サウジアラビア保健省、SFDA、WHO、CDC）",
    "ko": "지참해야 할 의약품 목록, 중요 각주 및 공식 참고자료 (Kemenkes, 사우디 보건부, SFDA, WHO, CDC)",
    "hi": "साथ ले जाने वाली दवाओं की सूची, महत्वपूर्ण फ़ुटनोट, और आधिकारिक संदर्भ (Kemenkes, Saudi MoH, SFDA, WHO, CDC)"
  },
  "packed": {
    "id": "{n}/{total} sudah dikemas",
    "en": "{n}/{total} already packed",
    "ar": "{n}/{total} تم تحضيره",
    "fr": "{n}/{total} déjà emballé(s)",
    "de": "{n}/{total} bereits gepackt",
    "es": "{n}/{total} ya empacado(s)",
    "ru": "{n}/{total} уже упаковано",
    "zh": "{n}/{total} 已打包",
    "ja": "{n}/{total} 準備済み",
    "ko": "{n}/{total} 이미 챙김",
    "hi": "{n}/{total} पहले से पैक किया गया"
  },
  "packedShort": {
    "id": "Dikemas",
    "en": "Packed",
    "ar": "تم التحضير",
    "fr": "Emballé",
    "de": "Gepackt",
    "es": "Empacado",
    "ru": "Упаковано",
    "zh": "已打包",
    "ja": "準備済み",
    "ko": "챙김",
    "hi": "पैक किया गया"
  },
  "markPacked": {
    "id": "Tandai sudah dikemas",
    "en": "Mark as packed",
    "ar": "علِّم كمحضَّر",
    "fr": "Marquer comme emballé",
    "de": "Als gepackt markieren",
    "es": "Marcar como empacado",
    "ru": "Отметить как упакованное",
    "zh": "标记为已打包",
    "ja": "準備済みにする",
    "ko": "챙긴 것으로 표시",
    "hi": "पैक किया हुआ चिह्नित करें"
  },
  "unmark": {
    "id": "Batalkan tanda",
    "en": "Unmark",
    "ar": "إلغاء التحديد",
    "fr": "Démarquer",
    "de": "Markierung aufheben",
    "es": "Desmarcar",
    "ru": "Снять отметку",
    "zh": "取消标记",
    "ja": "マークを外す",
    "ko": "표시 해제",
    "hi": "चिह्न हटाएं"
  },
  "tagWajib": {
    "id": "Penting",
    "en": "Important",
    "ar": "مهم",
    "fr": "Important",
    "de": "Wichtig",
    "es": "Importante",
    "ru": "Важно",
    "zh": "重要",
    "ja": "重要",
    "ko": "중요",
    "hi": "महत्वपूर्ण"
  },
  "tagDianjurkan": {
    "id": "Dianjurkan",
    "en": "Recommended",
    "ar": "موصى به",
    "fr": "Recommandé",
    "de": "Empfohlen",
    "es": "Recomendado",
    "ru": "Рекомендуется",
    "zh": "推荐",
    "ja": "推奨",
    "ko": "권장",
    "hi": "अनुशंसित"
  },
  "tagResep": {
    "id": "Perlu resep",
    "en": "Requires Prescription",
    "ar": "يستلزم وصفة طبية",
    "fr": "Nécessite une ordonnance",
    "de": "Rezeptpflichtig",
    "es": "Requiere receta",
    "ru": "Требует рецепта",
    "zh": "需要处方",
    "ja": "処方箋が必要",
    "ko": "처방전 필요",
    "hi": "नुस्खे की आवश्यकता है"
  },
  "tagOpsional": {
    "id": "Opsional",
    "en": "Optional",
    "ar": "اختياري",
    "fr": "Optionnel",
    "de": "Optional",
    "es": "Opcional",
    "ru": "Необязательно",
    "zh": "可选",
    "ja": "任意",
    "ko": "선택 사항",
    "hi": "वैकल्पिक"
  },
  "purposeLabel": {
    "id": "Kegunaan",
    "en": "Purpose",
    "ar": "الاستخدام",
    "fr": "Utilisation",
    "de": "Verwendungszweck",
    "es": "Uso",
    "ru": "Назначение",
    "zh": "用途",
    "ja": "用途",
    "ko": "용도",
    "hi": "उपयोग"
  },
  "noteLabel": {
    "id": "Catatan",
    "en": "Note",
    "ar": "ملاحظة",
    "fr": "Remarque",
    "de": "Hinweis",
    "es": "Nota",
    "ru": "Примечание",
    "zh": "备注",
    "ja": "メモ",
    "ko": "참고",
    "hi": "नोट"
  },
  "itemsCount": {
    "id": "{n} item",
    "en": "{n} item",
    "ar": "{n} عنصر",
    "fr": "{n} article",
    "de": "{n} Artikel",
    "es": "{n} artículo",
    "ru": "{n} позиция",
    "zh": "{n} 项",
    "ja": "{n} 件",
    "ko": "{n} 항목",
    "hi": "{n} आइटम"
  },
  "expandAll": {
    "id": "Buka semua",
    "en": "Expand all",
    "ar": "توسيع الكل",
    "fr": "Tout développer",
    "de": "Alle ausklappen",
    "es": "Expandir todo",
    "ru": "Развернуть все",
    "zh": "展开全部",
    "ja": "すべて展開",
    "ko": "모두 펼치기",
    "hi": "सभी खोलें"
  },
  "collapseAll": {
    "id": "Tutup semua",
    "en": "Collapse all",
    "ar": "طي الكل",
    "fr": "Tout réduire",
    "de": "Alle einklappen",
    "es": "Contraer todo",
    "ru": "Свернуть все",
    "zh": "折叠全部",
    "ja": "すべて折りたたむ",
    "ko": "모두 접기",
    "hi": "सभी बंद करें"
  },
  "reset": {
    "id": "Atur ulang",
    "en": "Reset",
    "ar": "إعادة ضبط",
    "fr": "Réinitialiser",
    "de": "Zurücksetzen",
    "es": "Restablecer",
    "ru": "Сбросить",
    "zh": "重置",
    "ja": "リセット",
    "ko": "초기화",
    "hi": "रीसेट करें"
  },
  "resetConfirm": {
    "id": "Hapus semua tanda \"sudah dikemas\"?",
    "en": "Remove all \"already packed\" marks?",
    "ar": "هل تريد إزالة جميع علامات \"تم تعبئته\"؟",
    "fr": "Supprimer toutes les marques « déjà emballé » ?",
    "de": "Alle Markierungen „bereits gepackt\" entfernen?",
    "es": "¿Eliminar todas las marcas de \"ya empacado\"?",
    "ru": "Удалить все отметки «уже упаковано»?",
    "zh": "删除所有\"已打包\"标记？",
    "ja": "「梱包済み」のマークをすべて削除しますか？",
    "ko": "\"이미 챙김\" 표시를 모두 제거할까요?",
    "hi": "सभी \"पहले से पैक किया गया\" चिह्न हटाएं?"
  },
  "resetDone": {
    "id": "Checklist obat diatur ulang",
    "en": "Medication checklist has been reset",
    "ar": "تمت إعادة تعيين قائمة الأدوية",
    "fr": "La liste des médicaments a été réinitialisée",
    "de": "Medikamentenliste wurde zurückgesetzt",
    "es": "La lista de medicamentos ha sido restablecida",
    "ru": "Список медикаментов сброшен",
    "zh": "药品清单已重置",
    "ja": "薬リストがリセットされました",
    "ko": "약품 체크리스트가 초기화되었습니다",
    "hi": "दवाओं की सूची रीसेट कर दी गई है"
  },
  "footnotesTitle": {
    "id": "Catatan kaki penting",
    "en": "Important footnotes",
    "ar": "ملاحظات تذييلية مهمة",
    "fr": "Notes de bas de page importantes",
    "de": "Wichtige Fußnoten",
    "es": "Notas al pie importantes",
    "ru": "Важные сноски",
    "zh": "重要脚注",
    "ja": "重要な脚注",
    "ko": "중요한 각주",
    "hi": "महत्वपूर्ण फ़ुटनोट"
  },
  "refsTitle": {
    "id": "Referensi",
    "en": "References",
    "ar": "المراجع",
    "fr": "Références",
    "de": "Referenzen",
    "es": "Referencias",
    "ru": "Источники",
    "zh": "参考资料",
    "ja": "参考文献",
    "ko": "참고 자료",
    "hi": "संदर्भ"
  },
  "fnRef": {
    "id": "Catatan {n}",
    "en": "Note {n}",
    "ar": "ملاحظة {n}",
    "fr": "Note {n}",
    "de": "Hinweis {n}",
    "es": "Nota {n}",
    "ru": "Примечание {n}",
    "zh": "注释 {n}",
    "ja": "注記 {n}",
    "ko": "각주 {n}",
    "hi": "नोट {n}"
  },
  "openLink": {
    "id": "Buka sumber",
    "en": "Open source",
    "ar": "فتح المصدر",
    "fr": "Ouvrir la source",
    "de": "Quelle öffnen",
    "es": "Abrir fuente",
    "ru": "Открыть источник",
    "zh": "打开来源",
    "ja": "ソースを開く",
    "ko": "출처 열기",
    "hi": "स्रोत खोलें"
  },
  "generalTips": {
    "id": "Tips kesehatan umum",
    "en": "General health tips",
    "ar": "نصائح صحية عامة",
    "fr": "Conseils de santé généraux",
    "de": "Allgemeine Gesundheitstipps",
    "es": "Consejos generales de salud",
    "ru": "Общие советы по здоровью",
    "zh": "一般健康建议",
    "ja": "一般的な健康アドバイス",
    "ko": "일반 건강 팁",
    "hi": "सामान्य स्वास्थ्य सुझाव"
  },
  "homeLink": {
    "id": "Obat penting ke Tanah Suci",
    "en": "Essential Medicines for the Holy Land",
    "ar": "الأدوية الضرورية للأراضي المقدسة",
    "fr": "Médicaments essentiels pour la Terre Sainte",
    "de": "Wichtige Medikamente für das Heilige Land",
    "es": "Medicamentos esenciales para la Tierra Santa",
    "ru": "Необходимые лекарства для Святой земли",
    "zh": "前往圣地的重要药品",
    "ja": "聖地への必須医薬品",
    "ko": "성지를 위한 필수 의약품",
    "hi": "पवित्र भूमि के लिए आवश्यक दवाएँ"
  },
  "homeHint": {
    "id": "Checklist obat, catatan kaki & referensi resmi",
    "en": "Medicine checklist, footnotes & official references",
    "ar": "قائمة تحقق من الأدوية، وملاحظات وافرة ومراجع رسمية",
    "fr": "Liste de contrôle des médicaments, notes de bas de page et références officielles",
    "de": "Medikamenten-Checkliste, Fußnoten und offizielle Referenzen",
    "es": "Lista de verificación de medicamentos, notas al pie y referencias oficiales",
    "ru": "Контрольный список лекарств, сноски и официальные источники",
    "zh": "药品清单、脚注及官方参考资料",
    "ja": "医薬品チェックリスト、脚注、および公式参考資料",
    "ko": "의약품 체크리스트, 각주 및 공식 참고 자료",
    "hi": "दवा चेकलिस्ट, फ़ुटनोट और आधिकारिक संदर्भ"
  },
  "profileTitle": {
    "id": "Kotak Obat Tanah Suci",
    "en": "Holy Land Medicine Kit",
    "ar": "حقيبة أدوية الأراضي المقدسة",
    "fr": "Trousse de médicaments pour la Terre Sainte",
    "de": "Medizinkoffer für das Heilige Land",
    "es": "Botiquín de medicamentos para la Tierra Santa",
    "ru": "Аптечка для Святой земли",
    "zh": "圣地药箱",
    "ja": "聖地用医薬品キット",
    "ko": "성지 의약품 키트",
    "hi": "पवित्र भूमि की दवा किट"
  },
  "profileHint": {
    "id": "{n} dari {total} item sudah dikemas",
    "en": "{n} of {total} items already packed",
    "ar": "{n} من {total} عنصر تم تجهيزه بالفعل",
    "fr": "{n} sur {total} articles déjà emballés",
    "de": "{n} von {total} Artikeln bereits eingepackt",
    "es": "{n} de {total} artículos ya empacados",
    "ru": "{n} из {total} предметов уже упаковано",
    "zh": "{n} / {total} 件物品已打包",
    "ja": "{total} 件中 {n} 件が梱包済み",
    "ko": "{total}개 중 {n}개 항목이 이미 포장됨",
    "hi": "{total} में से {n} वस्तुएँ पहले से पैक हो चुकी हैं"
  },
  "profileOpen": {
    "id": "Buka daftar obat",
    "en": "Open medicine list",
    "ar": "فتح قائمة الأدوية",
    "fr": "Ouvrir la liste des médicaments",
    "de": "Medikamentenliste öffnen",
    "es": "Abrir lista de medicamentos",
    "ru": "Открыть список лекарств",
    "zh": "打开药品清单",
    "ja": "医薬品リストを開く",
    "ko": "의약품 목록 열기",
    "hi": "दवा सूची खोलें"
  },
  "allPacked": {
    "id": "Alhamdulillah, semua perbekalan medis sudah dikemas!",
    "en": "Alhamdulillah, all medical supplies are already packed!",
    "ar": "الحمد لله، جميع الأدوية والمستلزمات الطبية قد تم تجهيزها!",
    "fr": "Alhamdulillah, toutes les fournitures médicales sont déjà emballées !",
    "de": "Alhamdulillah, alle medizinischen Bedarfsartikel sind bereits eingepackt!",
    "es": "Alhamdulillah, ¡todos los suministros médicos ya están empacados!",
    "ru": "Альхамдулиллях, все медицинские принадлежности уже упакованы!",
    "zh": "阿尔罕都里拉，所有医疗用品已全部打包完毕！",
    "ja": "アルハムドゥリッラー、すべての医療用品がすでに梱包されました！",
    "ko": "알함두릴라, 모든 의약품이 이미 포장되었습니다!",
    "hi": "अलहम्दुलिल्लाह, सभी चिकित्सा सामग्री पहले से पैक हो चुकी है!"
  },
  "syncNote": {
    "id": "Tersimpan di akun Anda dan tersinkron antar perangkat",
    "en": "Saved to your account and synced across devices",
    "ar": "محفوظ في حسابك ومزامَن عبر الأجهزة",
    "fr": "Enregistré sur votre compte et synchronisé sur tous vos appareils",
    "de": "In Ihrem Konto gespeichert und geräteübergreifend synchronisiert",
    "es": "Guardado en su cuenta y sincronizado entre dispositivos",
    "ru": "Сохранено в вашем аккаунте и синхронизировано на всех устройствах",
    "zh": "已保存至您的账户并在各设备间同步",
    "ja": "アカウントに保存され、デバイス間で同期されます",
    "ko": "계정에 저장되어 기기 간에 동기화됩니다",
    "hi": "आपके खाते में सहेजा गया और सभी डिवाइस पर सिंक किया गया"
  },
  "remindBtn": {
    "id": "Ingatkan minum obat",
    "en": "Remind me to take medication",
    "ar": "تذكيرني بتناول الدواء",
    "fr": "Me rappeler de prendre le médicament",
    "de": "Mich an die Medikamenteneinnahme erinnern",
    "es": "Recordarme tomar el medicamento",
    "ru": "Напомнить мне принять лекарство",
    "zh": "提醒我服药",
    "ja": "薬を飲む reminder を設定する",
    "ko": "약 복용 알림 설정",
    "hi": "दवा लेने की याद दिलाएं"
  },
  "remindActive": {
    "id": "Pengingat aktif",
    "en": "Reminder active",
    "ar": "التذكير مفعّل",
    "fr": "Rappel actif",
    "de": "Erinnerung aktiv",
    "es": "Recordatorio activo",
    "ru": "Напоминание активно",
    "zh": "提醒已启用",
    "ja": "リマインダー有効",
    "ko": "알림 활성화됨",
    "hi": "रिमाइंडर सक्रिय"
  },
  "remindTitle": {
    "id": "Pengingat minum obat",
    "en": "Medication reminder",
    "ar": "تذكير تناول الدواء",
    "fr": "Rappel de prise de médicament",
    "de": "Medikamentenerinnerung",
    "es": "Recordatorio de medicamento",
    "ru": "Напоминание о приёме лекарства",
    "zh": "服药提醒",
    "ja": "服薬リマインダー",
    "ko": "약 복용 알림",
    "hi": "दवा लेने का रिमाइंडर"
  },
  "remindHint": {
    "id": "Notifikasi harian pada waktu yang dipilih (waktu perangkat). Semua pengingat dapat dikelola di halaman Zikir Pagi & Petang.",
    "en": "Daily notification at the selected time (device time). All reminders can be managed on the Morning & Evening Dhikr page.",
    "ar": "إشعار يومي في الوقت المحدد (توقيت الجهاز). يمكن إدارة جميع التذكيرات من صفحة أذكار الصباح والمساء.",
    "fr": "Notification quotidienne à l'heure sélectionnée (heure de l'appareil). Tous les rappels peuvent être gérés sur la page Dhikr du matin et du soir.",
    "de": "Tägliche Benachrichtigung zur ausgewählten Zeit (Gerätezeit). Alle Erinnerungen können auf der Seite „Morgen- & Abend-Dhikr\" verwaltet werden.",
    "es": "Notificación diaria a la hora seleccionada (hora del dispositivo). Todos los recordatorios se pueden gestionar en la página de Dhikr de mañana y tarde.",
    "ru": "Ежедневное уведомление в выбранное время (время устройства). Всеми напоминаниями можно управлять на странице «Утреннее и вечернее зикр».",
    "zh": "每天在所选时间发送通知（设备时间）。所有提醒均可在晨昏祈祷页面中管理。",
    "ja": "選択した時刻（デバイス時刻）に毎日通知されます。すべてのリマインダーは「朝・夕のズィクル」ページで管理できます。",
    "ko": "선택한 시간(기기 시간)에 매일 알림이 전송됩니다. 모든 알림은 아침·저녁 지크르 페이지에서 관리할 수 있습니다.",
    "hi": "चयनित समय (डिवाइस समय) पर प्रतिदिन अधिसूचना। सभी रिमाइंडर सुबह और शाम के ज़िक्र पेज पर प्रबंधित किए जा सकते हैं।"
  },
  "remindTimes": {
    "id": "Waktu minum",
    "en": "Dosage times",
    "ar": "أوقات تناول الدواء",
    "fr": "Heures de prise",
    "de": "Einnahmezeiten",
    "es": "Horas de toma",
    "ru": "Время приёма",
    "zh": "服药时间",
    "ja": "服薬時刻",
    "ko": "복용 시간",
    "hi": "दवा लेने का समय"
  },
  "freq1": {
    "id": "1× sehari",
    "en": "1× daily",
    "ar": "مرة واحدة يومياً",
    "fr": "1× par jour",
    "de": "1× täglich",
    "es": "1× al día",
    "ru": "1× в день",
    "zh": "每日1次",
    "ja": "1日1回",
    "ko": "하루 1회",
    "hi": "दिन में 1 बार"
  },
  "freq2": {
    "id": "2× sehari",
    "en": "2× daily",
    "ar": "مرتان يومياً",
    "fr": "2× par jour",
    "de": "2× täglich",
    "es": "2× al día",
    "ru": "2× в день",
    "zh": "每天2次",
    "ja": "1日2回",
    "ko": "하루 2회",
    "hi": "दिन में 2 बार"
  },
  "freq3": {
    "id": "3× sehari",
    "en": "3× daily",
    "ar": "ثلاث مرات يومياً",
    "fr": "3× par jour",
    "de": "3× täglich",
    "es": "3× al día",
    "ru": "3× в день",
    "zh": "每天3次",
    "ja": "1日3回",
    "ko": "하루 3회",
    "hi": "दिन में 3 बार"
  },
  "addTime": {
    "id": "Tambah waktu",
    "en": "Add time",
    "ar": "إضافة وقت",
    "fr": "Ajouter une heure",
    "de": "Zeit hinzufügen",
    "es": "Añadir hora",
    "ru": "Добавить время",
    "zh": "添加时间",
    "ja": "時刻を追加",
    "ko": "시간 추가",
    "hi": "समय जोड़ें"
  },
  "remindDays": {
    "id": "Hari",
    "en": "Days",
    "ar": "الأيام",
    "fr": "Jours",
    "de": "Tage",
    "es": "Días",
    "ru": "Дни",
    "zh": "天数",
    "ja": "日",
    "ko": "요일",
    "hi": "दिन"
  },
  "remindSave": {
    "id": "Simpan pengingat",
    "en": "Save reminder",
    "ar": "حفظ التذكير",
    "fr": "Enregistrer le rappel",
    "de": "Erinnerung speichern",
    "es": "Guardar recordatorio",
    "ru": "Сохранить напоминание",
    "zh": "保存提醒",
    "ja": "リマインダーを保存",
    "ko": "알림 저장",
    "hi": "रिमाइंडर सहेजें"
  },
  "remindRemove": {
    "id": "Hapus pengingat",
    "en": "Remove reminder",
    "ar": "حذف التذكير",
    "fr": "Supprimer le rappel",
    "de": "Erinnerung entfernen",
    "es": "Eliminar recordatorio",
    "ru": "Удалить напоминание",
    "zh": "删除提醒",
    "ja": "リマインダーを削除",
    "ko": "알림 삭제",
    "hi": "रिमाइंडर हटाएं"
  },
  "remindSaved": {
    "id": "Pengingat \"{title}\" disimpan ({n} waktu)",
    "en": "Reminder \"{title}\" saved ({n} times)",
    "ar": "تم حفظ التذكير \"{title}\" ({n} مرة)",
    "fr": "Rappel \"{title}\" enregistré ({n} fois)",
    "de": "Erinnerung „{title}\" gespeichert ({n} Mal)",
    "es": "Recordatorio \"{title}\" guardado ({n} veces)",
    "ru": "Напоминание \"{title}\" сохранено ({n} раз)",
    "zh": "提醒\"{title}\"已保存（{n} 次）",
    "ja": "リマインダー「{title}」が保存されました（{n} 回）",
    "ko": "알림 \"{title}\" 저장됨 ({n}회)",
    "hi": "अनुस्मारक \"{title}\" सहेजा गया ({n} बार)"
  },
  "remindRemoved": {
    "id": "Pengingat obat dihapus",
    "en": "Medicine reminder removed",
    "ar": "تم حذف تذكير الدواء",
    "fr": "Rappel de médicament supprimé",
    "de": "Medikamentenerinnerung entfernt",
    "es": "Recordatorio de medicamento eliminado",
    "ru": "Напоминание о лекарстве удалено",
    "zh": "药物提醒已删除",
    "ja": "薬のリマインダーが削除されました",
    "ko": "약 복용 알림이 삭제되었습니다",
    "hi": "दवा का अनुस्मारक हटाया गया"
  },
  "remindTitleFmt": {
    "id": "Minum obat: {name}",
    "en": "Take medicine: {name}",
    "ar": "تناوَل الدواء: {name}",
    "fr": "Prendre le médicament : {name}",
    "de": "Medikament einnehmen: {name}",
    "es": "Tomar el medicamento: {name}",
    "ru": "Принять лекарство: {name}",
    "zh": "服药：{name}",
    "ja": "薬を飲む：{name}",
    "ko": "약 복용: {name}",
    "hi": "दवा लें: {name}"
  },
  "remindCount": {
    "id": "{n} pengingat obat aktif",
    "en": "{n} active medicine reminder(s)",
    "ar": "{n} تذكير دواء نشط",
    "fr": "{n} rappel(s) de médicament actif(s)",
    "de": "{n} aktive Medikamentenerinnerung(en)",
    "es": "{n} recordatorio(s) de medicamento activo(s)",
    "ru": "{n} активное напоминание о лекарстве",
    "zh": "{n} 个活跃药物提醒",
    "ja": "{n} 件の有効な薬のリマインダー",
    "ko": "활성 약 복용 알림 {n}개",
    "hi": "{n} सक्रिय दवा अनुस्मारक"
  },
  "manageReminders": {
    "id": "Kelola pengingat",
    "en": "Manage reminders",
    "ar": "إدارة التذكيرات",
    "fr": "Gérer les rappels",
    "de": "Erinnerungen verwalten",
    "es": "Gestionar recordatorios",
    "ru": "Управление напоминаниями",
    "zh": "管理提醒",
    "ja": "リマインダーを管理する",
    "ko": "알림 관리",
    "hi": "अनुस्मारक प्रबंधित करें"
  },
  "cancel": {
    "id": "Batal",
    "en": "Cancel",
    "ar": "إلغاء",
    "fr": "Annuler",
    "de": "Abbrechen",
    "es": "Cancelar",
    "ru": "Отмена",
    "zh": "取消",
    "ja": "キャンセル",
    "ko": "취소",
    "hi": "रद्द करें"
  },
  "disclaimer": {
    "id": "Informasi ini bersifat edukasi umum dan bukan pengganti konsultasi dokter. Nama obat adalah nama generik; ketersediaan, merek, dan aturan dapat berbeda di setiap negara. Selalu ikuti anjuran dokter, apoteker, dan petugas kesehatan rombongan.",
    "en": "This information is for general educational purposes and is not a substitute for medical consultation. Drug names are generic names; availability, brands, and regulations may differ by country. Always follow the advice of your doctor, pharmacist, and group health officer.",
    "ar": "هذه المعلومات ذات طابع تعليمي عام وليست بديلاً عن استشارة الطبيب. أسماء الأدوية هي أسماء جنيسة؛ وقد تختلف التوافر والعلامات التجارية والأنظمة من دولة إلى أخرى. اتبع دائماً إرشادات طبيبك وصيدلانيك والمسؤول الصحي في مجموعتك.",
    "fr": "Ces informations sont à titre éducatif général et ne remplacent pas une consultation médicale. Les noms des médicaments sont des noms génériques ; la disponibilité, les marques et les réglementations peuvent varier selon les pays. Suivez toujours les conseils de votre médecin, de votre pharmacien et du responsable médical de votre groupe.",
    "de": "Diese Informationen dienen allgemeinen Bildungszwecken und sind kein Ersatz für eine ärztliche Beratung. Arzneimittelnamen sind Generikanamen; Verfügbarkeit, Marken und Vorschriften können je nach Land variieren. Befolgen Sie stets die Anweisungen Ihres Arztes, Apothekers und des Gruppengesundheitsbeauftragten.",
    "es": "Esta información es de carácter educativo general y no reemplaza la consulta médica. Los nombres de los medicamentos son nombres genéricos; la disponibilidad, las marcas y las regulaciones pueden variar según el país. Siga siempre las indicaciones de su médico, farmacéutico y responsable de salud del grupo.",
    "ru": "Данная информация носит общеобразовательный характер и не заменяет консультацию врача. Названия препаратов являются генерическими; доступность, торговые марки и нормы могут различаться в зависимости от страны. Всегда следуйте рекомендациям вашего врача, фармацевта и медицинского сотрудника группы.",
    "zh": "本信息仅供一般教育目的，不能替代医疗咨询。药品名称为通用名称；各国的供应情况、品牌和规定可能有所不同。请始终遵循您的医生、药剂师及团队医疗负责人的建议。",
    "ja": "この情報は一般的な教育目的のものであり、医師への相談に代わるものではありません。薬品名は一般名（ジェネリック名）であり、入手可能性・ブランド・規制は国によって異なる場合があります。医師、薬剤師、および団体の医療担当者の指示に常に従ってください。",
    "ko": "이 정보는 일반적인 교육 목적으로 제공되며 의사 상담을 대체하지 않습니다. 약품명은 일반명(제네릭명)이며, 국가별로 가용성, 브랜드 및 규정이 다를 수 있습니다. 항상 의사, 약사 및 그룹 의료 담당자의 지시를 따르십시오.",
    "hi": "यह जानकारी सामान्य शैक्षिक उद्देश्यों के लिए है और यह डॉक्टर की परामर्श का विकल्प नहीं है। दवाओं के नाम जेनेरिक नाम हैं; उपलब्धता, ब्रांड और नियम प्रत्येक देश में भिन्न हो सकते हैं। हमेशा अपने डॉक्टर, फार्मासिस्ट और समूह के स्वास्थ्य अधिकारी की सलाह का पालन करें।"
  }
};
